export const authLinkClassName =
  'tw:h-auto tw:p-0 tw:text-app-dense tw:underline tw:underline-offset-auto tw:decoration-from-font'

export const authMutedLinkClassName = `${authLinkClassName} tw:text-muted-foreground tw:hover:text-primary`
